import $ from 'jquery';

$(document).ready(function () {

    $(document).on('click', 'a[href*=\\#]', function (e) {

        if ( $(this).hasClass('ui-tabs-anchor') )
            return false;

        const url = $(this).attr('href');
        const hash = url.substring(url.indexOf('#'));
        if ($(hash).length) {
            e.preventDefault();
            processHash(hash);
        }
    });

    function processHash(hash) {
        const $element = $(hash);

        if ($element.length) {

            $('html, body').animate({
                scrollTop: $element.offset().top
            }, 'normal');
        }
    }

    $(window).on("load", function () {
        if (location.hash) {
            processHash(location.hash);
        }
    });
});